import api from './interceptor'

// 获取收货地址列表
export const getAddressList = () => {
  return api.get('/customer-address')
}

// 添加收货地址
export const addAddressInfo = params => {
  return api.post('/customer-address', params)
}

// 修改收货地址
export const updateAddressInfo = params => {
  return api.put('/customer-address', params)
}

// 删除收货地址
export const deleteAddressInfo = id => {
  return api.delete(`/customer-address/${id}`)
}

// 获取收货地址
export const getAddressInfo = id => {
  return api.get(`/customer-address/${id}`)
}

// 获取个人信息
export const getProfile = () => {
  return api.get('/customer-profile')
}

// 添加个人信息
export const addProfile = params => {
  return api.post('/customer-profile', params)
}

// 修改个人信息
export const updateProfile = params => {
  return api.put('/customer-profile', params)
}

// 修改同意条款
export const updateAgreePushMsg = value => {
  return api.put(`/customer-profile/msg-agree/${value}`)
}

// 删除个人信息
export const deleteProfile = params => {
  return api.delete('/customer-profile', params)
}
